import "./headerStyles.scss";
const Header = () => {
  return (
    <header className="app-header" id="top">
      <div className="flex-content">
        <h1>I-ASCEND Program</h1>
        <nav>
          <a href="#overview">Overview</a>
          <a href="#scholarship">Scholarship Info</a>
          <a href="#application">Application</a>
          <a href="#program-directors">Program Directors</a>
        </nav>
      </div>
      <div className="mobile-banner">
        <h1>
          I-ASCEND Program
        </h1>
      </div>
    </header>
  );
};

export default Header;
